import { codeFileCreate } from "./query_functions/drs/File/CodeFile.create";
import { fileCreate } from "./query_functions/drs/File/File.create";
import { gdtAnalysisTableFillSources } from "./query_functions/library/gdt_analysis_table/gdt_analysis_table.fill_sources";
import { dataTableReorderRows } from "./query_functions/library/DataTable/DataTable.reorderRows";
import { dataTableRowDeleteRows } from "./query_functions/library/DataTableRow/DataTableRow.deleteRows";
import { dataTableRowCreateRows } from "./query_functions/library/DataTableRow/dataTableRowCreateRows";
import { gdtAnalysisTableReorderRows } from "./query_functions/library/GdtAnalysisTable/GdtAnalysisTable.reorderRows";
import { gdtAnalysisTableRowDeleteRows } from "./query_functions/library/GdtAnalysisTable/GdtAnalysisTableRow.deleteRows";
import { gdtAnalysisTableRowCreateRows } from "./query_functions/library/GdtAnalysisTableRow/gdtAnalysisTableRowCreateRows";
import { toolGet } from "./query_functions/trs/tool/Tool.get";
import { workflowValidateTables } from "./query_functions/wrs/Workflow/workflowValidateTables";
import { workflowCreate } from "./query_functions/wrs/Workflow/workflowCreate";
import { workflowTableRowDeleteRows } from "./query_functions/library/WorkflowTableRow/WorkflowTableRowDeleteRows";
import { workflowTableRowCreateRows } from "./query_functions/library/WorkflowTableRow/WorkflowTableRowCreateRows";
import { workflowTableRowExecute } from "./query_functions/library/WorkflowTableRow/WorkflowTableRowExecute";

/** API client for the IDEAS REST API */
export const DjangoClient = {
  /** Tool */
  tool: {
    get: toolGet,
  },
  file: {
    create: fileCreate,
  },
  code_file: {
    create: codeFileCreate,
  },
  library: {
    gdt_analysis_table: {
      fill_sources: gdtAnalysisTableFillSources,
      reorder_rows: gdtAnalysisTableReorderRows,
    },
    data_table: {
      reorder_rows: dataTableReorderRows,
    },
    data_table_row: {
      delete_rows: dataTableRowDeleteRows,
      create_rows: dataTableRowCreateRows,
    },
    gdt_analysis_table_row: {
      delete_rows: gdtAnalysisTableRowDeleteRows,
      create_rows: gdtAnalysisTableRowCreateRows,
    },
    workflow_table_row: {
      delete_rows: workflowTableRowDeleteRows,
      create_rows: workflowTableRowCreateRows,
      execute: workflowTableRowExecute,
    },
  },
  wrs: {
    workflow: {
      validateTables: workflowValidateTables,
      create: workflowCreate,
    },
  },
};
